import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchTrialBalance } from '@/renderer/services/accountingReportingService';

export function useTrialBalance(
  companyId: number | null,
  outletId: string | null | undefined,
  search: string,
  enabled = true,
) {
  return useQuery({
    queryKey: queryKeys.accounting.trialBalance(
      companyId ?? 0,
      outletId,
      search,
    ),
    queryFn: async () => {
      const result = await fetchTrialBalance(companyId!, outletId, search);
      if (!result.success) {
        throw new Error(result.error ?? 'Failed to fetch trial balance');
      }
      return result.data ?? [];
    },
    enabled: !!companyId && enabled,
  });
}
